import {
  REPORT_REVIEW_CHART_DATA_LOAD,
  REPORT_REVIEW_CHART_DATA_LOAD_SUCCESS,
  REPORT_REVIEW_CHART_DATA_LOAD_FAILURE,
  RESULT_ENTRY_CHART_DATA_LOAD,
  RESULT_ENTRY_CHART_DATA_LOAD_SUCCESS,
  RESULT_ENTRY_CHART_DATA_LOAD_FAILURE,
  REPORT_CAPA_CHART_DATA_LOAD,
  REPORT_CAPA_CHART_DATA_LOAD_SUCCESS,
  REPORT_CAPA_CHART_DATA_LOAD_FAILURE,
} from './actions'
import { prepareReportReviewChartData, prepareResultEntryChartData, prepareReportCapaChartData } from './helpers'

import { DEFAULT_DATE_RANGE } from 'utilities/dashboard/dateRange'

import type {
  ChartDataType,
  DashboardState,
} from './types'

import type { DashboardAction } from './actions'

const emptyRoundCount: ChartDataType[] = []
const emptyReportCount: ChartDataType[] = []
const emptyCapaCount: ChartDataType[] = []

export const initialState: DashboardState = {
  resultEntryChart: {
    isLoading: true,
    data: emptyRoundCount,
    dateRange: DEFAULT_DATE_RANGE,
    errors: [],
  },
  reportReviewChart: {
    isLoading: true,
    data: emptyReportCount,
    dateRange: DEFAULT_DATE_RANGE,
    errors: [],
  },
  reportCapaChart: {
    isLoading: true,
    data: emptyCapaCount,
    dateRange: DEFAULT_DATE_RANGE,
    errors: [],
  },
}

const reducer = (state: DashboardState = initialState, action: DashboardAction): DashboardState => {
  let chartData
  let errors
  switch (action.type) {
    case RESULT_ENTRY_CHART_DATA_LOAD:
      return {
        ...state,
        resultEntryChart: {
          ...initialState.resultEntryChart,
          dateRange: action.dateRange,
        }
      }

    case RESULT_ENTRY_CHART_DATA_LOAD_SUCCESS:
      chartData = prepareResultEntryChartData({ data: action.data })
      return {
        ...state,
        resultEntryChart: {
          ...state.resultEntryChart,
          data: chartData,
          errors: [],
          isLoading: false,
        }
      }

    case RESULT_ENTRY_CHART_DATA_LOAD_FAILURE:
      errors = action.errors
      return {
        ...state,
        resultEntryChart: {
          ...state.resultEntryChart,
          data: [],
          errors: errors,
          isLoading: false,
        }
      }

    case REPORT_REVIEW_CHART_DATA_LOAD:
      return {
        ...state,
        reportReviewChart: {
          ...initialState.reportReviewChart,
          dateRange: action.dateRange,
        }
      }

    case REPORT_REVIEW_CHART_DATA_LOAD_SUCCESS:
      chartData = prepareReportReviewChartData({ data: action.data })
      return {
        ...state,
        reportReviewChart: {
          ...state.reportReviewChart,
          data: chartData,
          errors: [],
          isLoading: false,
        }
      }

    case REPORT_REVIEW_CHART_DATA_LOAD_FAILURE:
      errors = action.errors
      return {
        ...state,
        reportReviewChart: {
          ...state.reportReviewChart,
          data: [],
          errors: errors,
          isLoading: false,
        }
      }

    case REPORT_CAPA_CHART_DATA_LOAD:
      return {
        ...state,
        reportCapaChart: {
          ...initialState.reportCapaChart,
          dateRange: action.dateRange,
        }
      }

    case REPORT_CAPA_CHART_DATA_LOAD_SUCCESS:
      chartData = prepareReportCapaChartData({ data: action.data })
      return {
        ...state,
        reportCapaChart: {
          ...state.reportCapaChart,
          data: chartData,
          errors: [],
          isLoading: false,
        }
      }

    case REPORT_CAPA_CHART_DATA_LOAD_FAILURE:
      errors = action.errors
      return {
        ...state,
        reportCapaChart: {
          ...state.reportCapaChart,
          data: [],
          errors: errors,
          isLoading: false,
        }
      }

    default:
      return state
  }
}

export default reducer
